<template>
    <div class="leave-index" >
        <!-- <myBreadCrumb :urls="JSON.stringify(breadcrumbs)" @createForm="dialog.state=true" :icon="icon"></myBreadCrumb> -->
        <!-- <create-dialog v-model="dialog" @CloseDialog="closeHandler" @fetchData="fetchData"></create-dialog> -->
        <v-card>
            <v-card-title>
                <v-text-field outlined hide-details 
                placeholder="Nhập Mã NS, tên NS,... để tìm kiếm" 
                v-model="globalSearch" label="Tìm kiếm" persistent-placeholder
                style="max-width: 300px;"
                ></v-text-field>
                <!-- <v-checkbox label="Chuyển vùng" v-model="changeArea" @change="fetchData" class="mx-2"></v-checkbox> -->

                <v-spacer></v-spacer>
                <!-- approve deny button -->
                <v-sheet levation="0" class="rounded-lg pa-2" color="grey lighten-2" v-if="selected.length > 0">
                    <v-btn color="error" @click="rejectDialog=true">Từ chối </v-btn>
                    <v-btn color="success" class="ml-2" @click="confirmHandler" type="button">Xác nhận</v-btn>
                </v-sheet>

                <!-- table controll buttons -->
                <v-btn color="teal" @click="fetchData" icon><v-icon color="teal">mdi-refresh</v-icon></v-btn>
                <v-btn @click="exportExcel" color="teal" icon> <v-icon>mdi-microsoft-excel</v-icon></v-btn>
                <!-- <create-button @click="dialog.state=true" ></create-button> -->
                <v-divider vertical class="mx-2"></v-divider>
                <month-picker width="7rem" v-model="month" label="Chọn tháng" outlined dense></month-picker>
                <!-- <data-filter v-model="params" :filter="filter" @fetchData="fetchData"></data-filter> -->
            </v-card-title>
        </v-card>
        <v-card v-if="true" class="mt-5">
            <v-data-table height="600px" dense fixed-header
            :search="globalSearch"
            :mobile-breakpoint="0"
            :headers="headers"
            :items="items"
            single-select
            v-model="selected"

            :loading="isLoading"
            loading-text="Đang tải dữ liệu..."
            >
                <template v-slot:item.actions="{ item }">
                    <v-btn color="primary" x-small v-show="!(item.isReject || item.confirmLevel >= 3)" @click="selected=[item]" width="100px">Xác nhận</v-btn>
                    
                    <v-btn color="error" x-small v-show="!(item.isReject || item.confirmLevel >= 3)" @click="rejectDialog=true, rejectItem=item" width="100px">Từ chối</v-btn>
                </template>
                <template v-slot:item.workDate="{ item }">
                    {{ new Date(item.workDate).toLocaleDateString('vi-VN') }}
                </template>
                
                <template v-slot:item.createdAt="{ item }">
                    {{ new Date(item.createdAt).toLocaleDateString('vi-VN') }} - {{ new Date(item.createdAt).toLocaleTimeString('vi-VN') }}
                </template>

                <template v-slot:item.managerName="{ item }">
                    <div :class="item.confirmLevel >= 1 ? 'green--text' : item.isReject ?  'red--text' : ''">
                        {{ item.managerName }} - {{ item.managerCode }}
                        <p>
                            <small :class="item.confirmLevel >= 1 && !item.isReject ? 'green--text' : ''">
                                {{ item.confirmLevel >= 1 ? 'Xác nhận' : '' }}
                            </small>
                            <small :class="item.confirmLevel >= 1  && !item.isReject ? 'red--text' : ''">
                                {{  item.isReject && item.managerCode == item.rejectedByCode ? 'Từ chối' : '' }}
                            </small>
                        </p>
                    </div>
                </template>
                <template v-slot:item.hrAdminName="{ item }">
                    <div :class="item.confirmLevel >= 2? 'green--text' : item.isReject ?  'red--text' : ''">
                        {{ item.hrAdminName }} - {{ item.hrAdminCode }}
                        <p>
                            <small :class="item.confirmLevel >= 2 && !item.isReject ? 'green--text' : '' ">
                                {{ item.confirmLevel >= 2  ? 'Xác nhận' : '' }}
                            </small>
                            <small :class="item.confirmLevel >= 2  && !item.isReject ? 'red--text' : ''">
                                {{  item.isReject && item.hrAdminCode == item.rejectedByCode ? 'Từ chối' : '' }}
                            </small>
                        </p>
                    </div>
                </template>
                <template v-slot:item.hrManagerName="{ item }">
                    <div :class="item.confirmLevel >= 3 ? 'green--text' : item.isReject ?  'red--text' : ''">
                        {{ item.hrManagerName }} - {{ item.hrManagerCode }}
                        <p>
                            <small :class="item.confirmLevel >= 3 && !item.isReject ? 'green--text' : ''">
                                {{ item.confirmLevel >= 3 ? 'Xác nhận' : '' }}
                            </small>
                            
                            <small :class="item.confirmLevel >= 3 && item.isReject ? 'red--text' : ''">
                                {{ item.isReject && item.hrManagerCode == item.rejectedByCode ? 'Từ chối' : '' }}
                            </small>
                        </p>
                    </div>
                </template>
                
                    <template v-slot:item.confirmLevel="{ item }">
                        <div v-if="item.isReject" :class="item.isReject ? 'red--text' : ''">Từ chối</div>
                        <div v-if="item.confirmLevel == 0 && !item.isReject">Tạo mới</div>
                        <div v-if="item.confirmLevel == 1 && !item.isReject">Quản lý đã duyệt</div>
                        <div v-if="item.confirmLevel == 2 && !item.isReject">HR đã duyệt</div>
                        <div v-if="item.confirmLevel == 3 && !item.isReject" :class="item.confirmLevel ==3 ? 'green--text' : ''">Hoàn tất</div>
                    </template>
                    
                <template v-slot:item.imageUrl="{ item }">
                    <v-img :src="item.imageUrl" max-width="50" @click="viewUrl = item.imageUrl, selected[0]=item"></v-img>
                </template>

                <template v-slot:item.note="{ item }">
                    <p><b>Nhân viên: </b> {{ item.note }}</p>
                    <p><b>Quản lý: </b> {{ item.managerNote }}</p>
                    <p><b>Admin: </b> {{ item.hrAdminNote }}</p>
                    <p><b>HR Director: </b> {{ item.hrManagerNote }}</p>
                </template>
                
                <template v-slot:item.confirmedWorktime="{ item }">
                    <p><b>Quản lý: </b> {{ item.confirmWorktimeManager }}</p>
                    <p><b>Admin: </b> {{ item.confirmWorktimeHrAdmin }}</p>
                    <p><b>HR Director (Cuối cùng): </b> {{ item.confirmWorktime }}</p>
                </template>
              
                <template v-slot:body.prepend>
                    <tr style="position: sticky;
                                top: 48px;
                                background: white;
                                z-index: 3;">
                    <td></td>
                    <td>
                        <v-text-field outlined dense hide-details=""
                        v-model="idSearch"
                        label=""
                        ></v-text-field>
                    </td>
                    <td> 
                        <v-text-field outlined dense hide-details=""
                        v-model="employeeCodeSearch"
                        label=""
                        ></v-text-field>
                    </td>
                    <td> 
                        <v-text-field outlined dense hide-details=""
                        v-model="employeeNameSearch"
                        label=""
                        ></v-text-field>
                    </td>
                    <td> 
                        <v-text-field outlined dense hide-details=""
                        v-model="departmentNameSearch"
                        label=""
                        ></v-text-field>
                    </td>
                    <td> 
                        <v-text-field outlined dense hide-details=""
                        v-model="divisionNameSearch"
                        label=""
                        ></v-text-field>
                    </td>
                    <td colspan="8"></td>
                    </tr>
                </template>
            </v-data-table>
        </v-card>
        <!-- ************** DELETE CONFIRMATION *************** -->
        <v-dialog :value="selected.length>0" max-width="500px" v-if="selected.length>0" persistent>
            <v-card>
                <v-card-title class="text-subtitle-1">Xác nhận phiếu này <v-spacer></v-spacer> <v-icon @click="selected=[]">mdi-close</v-icon></v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="12">
                            <v-text-field outlined dense label="Mã nhân viên" readonly :value="info.employeeCode" hide-details="auto"></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field outlined dense label="Tên nhân viên" readonly :value="info.employeeName" hide-details="auto"></v-text-field>
                        </v-col>
                        <v-col cols="6">
                            <v-text-field dense label="Giờ check-in" readonly :value="info.checkIn" hide-details="auto"></v-text-field>
                            <!-- <span v-else class="warning--text">* Nhân viên chưa check-in *</span> -->
                        </v-col>
                        <v-col cols="6">
                            <v-text-field dense label="Giờ check-out" readonly :value="info.checkOut" hide-details="auto"></v-text-field>
                            <!-- <span v-else class="warning--text"> * Nhân viên chưa check-out *</span> -->
                        </v-col>
                        <v-col cols="12">
                            <v-text-field label="Giờ công thực tế" readonly :value="info.actualTime" hide-details="auto"></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field label="Giờ công nhân viên đề xuất xác nhận" readonly :value="info.wantedTime" hide-details="auto"></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field outlined label="Giờ công xác nhận cuối cùng" v-model="info.confirmedTime" hide-details="auto"></v-text-field>
                            <small class="error--text">Cần nhập giờ công xác nhận lại ở cấp xác nhận cuối cùng </small>
                        </v-col>
                        
                        <v-col cols="12">
                            <v-textarea outlined label="Ghi chú/Bình luận" v-model="info.confirmNote"></v-textarea>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="success" type="button" @click="confirmHandler">Xác nhận</v-btn>
                <!-- <v-btn color="blue darken-1" @click="cfmDeleteItem">OK</v-btn> -->
                <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog :value="!!viewUrl" persistent fullscreen>
            <v-card dark>
            <v-card-title>
                Xem ảnh
                <v-spacer></v-spacer>
                <v-icon @click="viewUrl=null, selected=[]">mdi-close</v-icon>
            </v-card-title>
            <v-card-subtitle>Địa điểm: {{ selected[0]?.address }}, IP: {{selected[0] ? (selected[0]?.ipName ?? 'Không có dữ liệu') : 'Không có dữ liệu'}}</v-card-subtitle>
            <v-row>
                <v-col cols="12" md="8">
                    <v-img :src="viewUrl" style="max-height: calc(100vh - 110px);" contain></v-img>
                </v-col>
                <v-col cols="12" md="4">
                    <!-- comments -->
                     <v-card style="min-height: calc(100vh - 110px);;" light class="rounded-xl">
                        <v-card-text>
                            <v-card-title>Ghi chú</v-card-title>

                            <v-timeline dense>
                                <v-slide-x-reverse-transition
                                group
                                hide-on-leave
                                >
                                <v-timeline-item
                                    :key="1"
                                    color="info"
                                    small
                                    fill-dot
                                >
                                    <v-card class="info white--text">
                                        <v-card-title>
                                            <v-icon class="mr-2">
                                                mdi-alert-circle
                                            </v-icon>
                                            Quản lý
                                        </v-card-title>
                                        <v-card-text class="white--text">
                                            {{selected[0] ? (selected[0]?.managerNote ?? 'Không có ghi chú nào.') : 'Không có ghi chú nào.'}}
                                        </v-card-text>
                                    </v-card>
                                </v-timeline-item>
                                
                                <v-timeline-item
                                    :key="1"
                                    color="info"
                                    small
                                    fill-dot
                                >
                                    <v-card class="info white--text">
                                        <v-card-title>
                                            <v-icon class="mr-2">
                                                mdi-alert-circle
                                            </v-icon>
                                            Admin HR
                                        </v-card-title>
                                        <v-card-text class="white--text">
                                            {{selected[0] ? (selected[0]?.hrAdminNote ?? 'Không có ghi chú nào.') : 'Không có ghi chú nào.'}}
                                        </v-card-text>
                                    </v-card>
                                </v-timeline-item>
                                
                                <v-timeline-item
                                    :key="1"
                                    color="info"
                                    small
                                    fill-dot
                                >
                                    <v-card class="info white--text">
                                        <v-card-title>
                                            <v-icon class="mr-2">
                                                mdi-alert-circle
                                            </v-icon>
                                            Giám đốc nhân sự
                                        </v-card-title>
                                        <v-card-text class="white--text">
                                            {{selected[0] ? (selected[0]?.hrManagerNote ?? 'Không có ghi chú nào.') : 'Không có ghi chú nào.'}}
                                        </v-card-text>
                                    </v-card>
                                </v-timeline-item>
                                </v-slide-x-reverse-transition>
                            </v-timeline>
                        </v-card-text>
                     </v-card>
                </v-col>
            </v-row>
            </v-card>
        </v-dialog>
        <v-dialog v-model="rejectDialog" persistent width="400px">
            <v-card>
                <v-card-title class="text-subtitle-1">
                    Từ chối phiếu 
                    <v-spacer></v-spacer>
                    <v-icon @click="rejectDialog=false, rejectItem = null">mdi-close</v-icon>
                </v-card-title>
                <v-card-text>
                    <v-text-field v-model="rejectNote" dense outlined hide-details label="Lý do"></v-text-field>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-btn @click="rejectHandler(rejectItem)" color="teal darken-4" dark>OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import * as moment from "moment/moment";
import CreateButton from '@/components/Crud/CreateButton';
import http from '@/components/services/http-common';
import Create from '@/views/Request/EmployeeRotation/Create.vue';
import DataFilter from '@/components/DataFilter.vue';
import headers from "./header";
import { get, confirm, reject, getInfo } from "./api"

const minDate = new Date("0001-01-01T00:00:00Z");
export default {
    name: 'Leave',
    components: {
        CreateButton,
        "create-dialog": Create,
        "data-filter": DataFilter
    },
    watch: {
        tableParams: {
            handler (val) {
                this.fetchData();
                this.fetchCity();
            },
            deep: true,
        },
        filters: {
            handler (val) {
                this.tableParams.page=1;
                this.fetchData();
            },
            deep: true,
        },
        month: {
            handler(val)
            {
                this.filters.from = moment(val, "YYYY-MM").startOf("month").format("YYYY-MM-DD");
                this.filters.to = moment(val, "YYYY-MM").endOf("month").format("YYYY-MM-DD");
            }
        },
        selected: {
            handler(val) {
                if(val.length > 0){
                    this.getInfo()
                }else {
                    // this.info = {}
                }
            }
        }
    },
    data() {
        return {
            ROOT_URL: "EmployeeRotationRequests/",

            //HEADER DATA
            icon:{
                icon: "mdi-plus-thick",
                to: ""
            },
            idSearch: null,
            employeeCodeSearch: '',
            employeeNameSearch: '',
            departmentNameSearch: '',
            divisionNameSearch: '',

            //filters
            month: moment().format("YYYY-MM"),
            changeArea: false,
            globalSearch:"",
            filters:{
                code:null,
                employeeName:null,
                from: moment().startOf("month").format("YYYY-MM-DD"),
                to: moment().endOf("month").format("YYYY-MM-DD"),
            },
            tableParams: {
                sortBy: [],
                sortDesc: [],
                page: 1,
            },
            selected: [],
            rowCount: 0,


            items: [],
            options: {},
            isLoading: true,

            //DIALOG
            dialog: {
                state: false,
                item: undefined,
            },
            confirmDialog: false,
            targetItem: {},
            viewUrl: "",
            info: {
                employeeName:"",
                checkIn: null,
                checkOut: null,
                actualTime: null,
                wantedTime: null,
                confirmedTime: null,
                confirmNote: null
            },
            rejectDialog: false,
            rejectNote: '',
            rejectItem: null
        }
    },
    computed: {
        webAllowed() {
            let user = localStorage.getItem("user");
            let webAllowed = localStorage.getItem("WebAllowed");
            user = JSON.parse(user);
            return webAllowed.includes(user.employeeCode);
        },
        params: function() {
            return {...this.tableParams, ...this.filters}
        },
        
        //TABLE
        headers: function() {
            return headers(this.idSearch, this.employeeCodeSearch, this.employeeNameSearch, this.departmentNameSearch, this.divisionNameSearch)
        }
    },

    methods: {
        
        colorClass(value) {
            switch (value) {
            case 0: return "primary"
            case 1: return "green darken-3"
            case 2: return "red darken-3"
            default: return ""
            }
        },
        formatDate(value) {
            return moment(value).format("DD/MM/YYYY");
        },
        
        status(value) {
            let result = {};
            switch(value) {
                case 0: {
                    result.text = "Chờ duyệt";
                    result.color = "warning"
                    break;
                }
                case 1: {
                    result.text = "Đã duyệt"
                    result.color = "success"
                    break;
                }
                case 2: {
                    result.text = "Từ chối"
                    result.color = "error"
                    break;
                }
                default:{
                    result.text = "unknown"
                    break;
                }
            }
            return result;
        },

        //DATA JS
        fetchData () {
            return get(this.month)
            .then(res => {
                this.items = res.data.data;
                // this.rowCount = res.data;
                this.isLoading = false;
            })
        },
        exportExcel(){
            return http.get(this.ROOT_URL+"hr/export", {
                params: {
                    month: moment(this.month).format('YYYY-MM-DD')
                },
                responseType: 'blob',
            }).then(res => {
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `DANH SACH_PHIEU_HT_${moment(this.month, 'yyyy-MM-dd').format("MM-YYYY")}.xlsx`);
                document.body.appendChild(link);
                link.click();
            });
        },

        changeItemStatus(id, status){
            return http.get(`${this.ROOT_URL}hr/change-status`, {
                params: {
                    id: id,
                    status: status
                }
            })
            .catch(()=> {this.fetchData()})
        },

        //DIALOG METHOD
        openDialog() {
            this.params = {
            }
        },
        closeHandler () {
            this.dialog = {state: false, item: undefined}
        },
        editItem (item) {
            this.dialog = {state: true, item: item}
        },
        deleteItem (item) {
            this.confirmDialog = true;
            this.targetItem = item;
        },
        cfmDeleteItem() {
            http.delete(this.ROOT_URL + "undo/" +this.targetItem.id).then(res => {
                this.fetchData();
                this.confirmDialog = false;
            }).catch(err => {
                switch (err.response.status)
                {
                    case 403:{
                        this.unauthorizeAlert();
                        this.confirmDialog = false;
                        break;
                    }
                    default:
                        break;
                }
            })
        },

        confirmHandler() {
            confirm(this.selected, this.info.confirmedTime, this.info.confirmNote).then(r => {
                console.log(r)
                this.fetchData()
                this.selected = []
            })
        },

        rejectHandler(selected) {
            reject([selected], this.rejectNote).then(r => {
                console.log(r)
                this.selected = []
                this.fetchData()
            })
        },

        getInfo() {
            return getInfo(this.selected[0].id).then(r => {
                this.info = {...r.data.data, 
                    checkIn: moment(r.data.data.checkIn).format("DD/MM/YYYY HH:mm:ss"),
                    checkOut: moment(r.data.data.checkOut).format("DD/MM/YYYY HH:mm:ss"),
                }
                console.log(this.info)
            })
        }

    },
    
    mounted() {

        this.fetchData().then(() => {
            const refId = this.$route.query.refId;
            if(refId) {
                this.idSearch = refId
            }
        })
        
    }
}
</script>

<style scoped>
    /* ::v-deep table > thead {
        background: white !important;
    } */
</style>